import React, { useState } from 'react';
import { FiX, FiPhone, FiUser } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './addRetailer.css';

const AddRetailer = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    contact_number: '',
    email: '',
    pan_number: '',
    address: '',
    due_amount: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiError, setApiError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) {
      newErrors.name = 'Retailer name is required';
    }
    if (!formData.contact_number.trim()) {
      newErrors.contact_number = 'Contact number is required';
    } else if (!/^[0-9]{10,15}$/.test(formData.contact_number)) {
      newErrors.contact_number = 'Enter a valid contact number';
    }
    if (!formData.address.trim()) {
      newErrors.address = 'Address is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError(null);
    
    if (validateForm()) {
      setIsSubmitting(true);
      try {
        const response = await axios.post('/retailers', formData);
        console.log('Retailer added successfully:', response.data);
        navigate('/retailers');
      } catch (err) {
        console.error('Error adding retailer:', err);
        
        if (err.response) {
          // Server responded with an error status (4xx, 5xx)
          setApiError(err.response.data.error || 'Failed to add retailer');
          
          // Handle validation errors from backend
          if (err.response.status === 400 && err.response.data.errors) {
            const backendErrors = {};
            err.response.data.errors.forEach(error => {
              backendErrors[error.path] = error.msg;
            });
            setErrors(backendErrors);
          }
        } else if (err.request) {
          // Request was made but no response received
          setApiError('Network error. Please check your connection.');
        } else {
          // Something happened in setting up the request
          setApiError('An unexpected error occurred.');
        }
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div className="add-retailer-container">
      <div className="add-retailer-header">
        <h1 className="add-retailer-title">New Retailer</h1>
        <button 
          className="cancel-btn"
          onClick={() => navigate('/retailers')}
          disabled={isSubmitting}
        >
          <FiX /> Cancel
        </button>
      </div>

      <form onSubmit={handleSubmit} className="retailer-form">
        <div className={`form-group ${errors.name ? 'has-error' : ''}`}>
          <h3>Enter retailer details</h3>
          <label htmlFor="name">
            <FiUser className="input-icon" />
            Retailer Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter retailer name"
            className={errors.name ? 'error-input' : ''}
            disabled={isSubmitting}
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className={`form-group ${errors.contact_number ? 'has-error' : ''}`}>
          <label htmlFor="contact_number">
            <FiPhone className="input-icon" />
            Contact Number
          </label>
          <input
            type="tel"
            id="contact_number"
            name="contact_number"
            value={formData.contact_number}
            onChange={handleChange}
            placeholder="Enter 10 digit number"
            className={errors.contact_number ? 'error-input' : ''}
            disabled={isSubmitting}
          />
          {errors.contact_number && <span className="error-message">{errors.contact_number}</span>}
        </div>

        <div className={`form-group ${errors.email ? 'has-error' : ''}`}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter retailer email"
            disabled={isSubmitting}
          />
          {errors.email && <span className="error-message">{errors.email}</span>}
        </div>
        <div className={'form-group' }>
          <label htmlFor="email">Pan Number</label>
          <input
            id="pan_number"
            name="pan_number"
            value={formData.pan_number}
            onChange={handleChange}
            placeholder="Enter retailer pan"
            disabled={isSubmitting}
          />
        </div>

        <div className={`form-group ${errors.address ? 'has-error' : ''}`}>
          <label htmlFor="address">Address *</label>
          <input
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter retailer address"
            className={errors.address ? 'error-input' : ''}
            disabled={isSubmitting}
          />
          {errors.address && <span className="error-message">{errors.address}</span>}
        </div>

         <div className={'form-group' }>
            <label htmlFor="email">Opening Balance</label>
            <input
              type='number'
              id="due_amount"
              name="due_amount"
              value={formData.due_amount}
              onChange={handleChange}
              placeholder="Enter retailer opening balance"
              disabled={isSubmitting}
              onWheel={(e) => e.target.blur()}
            />
          </div>

        {apiError && (
          <div className="api-error-message">
            {apiError}
          </div>
        )}

        <div className="form-actions">
          <button
            type="submit"
            className="submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Saving...' : 'Save'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddRetailer;